import queue from 'chimera/all/store/queue'

export default queue
